var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.9c06bfb67492970773ac65f5e989382a.svg#L';
                    var viewUrl = 'sprites.9c06bfb67492970773ac65f5e989382a.svg#view-L';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };